module.exports = __webpack_public_path__ + "img/1.43711bfb.jpg";